

















































import {
  deleteTextTemplate,
  getTextTemplates,
  saveTextTemplate,
  TextTemplate
} from "@/api/text-templates-api";
import TextTemplateForm, {
  TextTemplateFormData
} from "@/components/TextTemplateForm.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    TextTemplateForm
  },
  model: {
    prop: "visible",
    event: "change"
  }
})
export default class TextTemplateModal extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: String, default: "" }) category!: string;

  mode: "use" | "edit" = "use";

  template: TextTemplateFormData = {
    id: "",
    text: ""
  };
  templates: TextTemplate[] = [];

  change(visible: boolean) {
    this.$emit("change", visible);
  }

  async initTextTemplates() {
    this.templates = await getTextTemplates({ category: this.category });
  }

  show() {
    this.mode = "use";
    this.initTextTemplates();
  }

  create() {
    this.template = {
      id: "",
      text: ""
    };
    this.mode = "edit";
  }

  apply(template: TextTemplate) {
    this.$emit("apply", template.body);
  }

  edit(template: TextTemplate) {
    this.template = {
      id: template.id,
      text: template.body
    };
    this.mode = "edit";
  }

  async destroy(template: TextTemplate) {
    const confirmed = confirm(
      `テンプレート「${template.body}」を削除してもよろしいですか？`
    );
    if (!confirmed) {
      return;
    }
    await deleteTextTemplate(template.id);
    await this.initTextTemplates();
  }

  async save(data: TextTemplateFormData) {
    await saveTextTemplate({
      id: data.id,
      body: data.text,
      category: this.category
    });
    await this.initTextTemplates();
    this.mode = "use";
  }

  goBack() {
    this.mode = "use";
  }
}
